/* Bushnell Utility Bar — moved out of sections/bushnell-utility-bar.liquid's
   inline <script>. This section renders on every page (layout/theme.liquid,
   layout/bushnell-theme.liquid), and the code is fully static — no Liquid
   variables — so it's identical on every page load. As an external file it's
   fetched once and cached, instead of being re-sent inline with every page's
   HTML. */
(function () {
  if (window.__bnCardArrows) return;
  window.__bnCardArrows = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gallery-prev], [data-gallery-next]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var gallery = btn.closest('.p-card-gallery');
    if (!gallery) return;
    var track = gallery.querySelector('[data-card-gallery-track]');
    if (!track) return;
    var slides = track.querySelectorAll('.p-card-gallery-slide');
    var count = slides.length;
    if (count <= 1) return;
    var amount = track.clientWidth || track.offsetWidth;
    var idx = Math.round(track.scrollLeft / amount);
    var next;
    if (btn.hasAttribute('data-gallery-prev')) {
      next = idx <= 0 ? count - 1 : idx - 1;          /* first → wrap to last */
    } else {
      next = idx >= count - 1 ? 0 : idx + 1;          /* last → wrap to first */
    }
    track.scrollTo({ left: next * amount, behavior: 'smooth' });
  });

  /* Account dropdown: click-to-toggle, fixed-positioned to the trigger so it
     survives ancestor stacking/overflow contexts (hover-only died when the
     pointer crossed the main nav on the way to the menu). */
  document.addEventListener('click', function (e) {
    var openAccts = document.querySelectorAll('.utility-account.bn-open');
    var acct = e.target.closest('.utility-account');
    if (!acct) {
      openAccts.forEach(function (a) { a.classList.remove('bn-open'); });
      return;
    }
    var trigger = acct.querySelector('a');
    var menu = acct.querySelector('.bn-acct-menu');
    if (menu && trigger && (e.target === trigger || trigger.contains(e.target))) {
      e.preventDefault();
      var willOpen = !acct.classList.contains('bn-open');
      openAccts.forEach(function (a) { a.classList.remove('bn-open'); });
      if (willOpen) {
        var r = trigger.getBoundingClientRect();
        menu.style.top = Math.round(r.bottom) + 'px';
        menu.style.left = Math.max(8, Math.round(r.right - 240)) + 'px';
        acct.classList.add('bn-open');
      }
    }
  });
  /* Region dropdown: same click-toggle + fixed positioning as the account menu. */
  document.addEventListener('click', function (e) {
    var openRegions = document.querySelectorAll('.utility-region.bn-open');
    var region = e.target.closest('.utility-region');
    if (!region) {
      openRegions.forEach(function (r) { r.classList.remove('bn-open'); });
      return;
    }
    var trigger = region.querySelector('.bn-region-trigger');
    var menu = region.querySelector('.bn-region-menu');
    if (menu && trigger && trigger.contains(e.target)) {
      var willOpen = !region.classList.contains('bn-open');
      openRegions.forEach(function (r) { r.classList.remove('bn-open'); });
      if (willOpen) {
        var rect = trigger.getBoundingClientRect();
        menu.style.top = Math.round(rect.bottom) + 'px';
        menu.style.left = Math.max(8, Math.min(Math.round(rect.left), window.innerWidth - 198)) + 'px';
        region.classList.add('bn-open');
      }
    }
  });

  window.addEventListener('scroll', function () {
    document.querySelectorAll('.utility-account.bn-open, .utility-region.bn-open').forEach(function (a) { a.classList.remove('bn-open'); });
  }, { passive: true });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.utility-account.bn-open, .utility-region.bn-open').forEach(function (a) { a.classList.remove('bn-open'); });
    }
  });

  /* Comparison-chart normalizer: give every category's chart the
     rangefinders treatment — prices under product names instead of a
     "Price" line item, plus heading + legend when the chart lacks one. */
  document.addEventListener('DOMContentLoaded', function () {
    var chart = document.getElementById('lrf-comparison-chart');
    if (!chart) return;

    var rows = chart.querySelectorAll('.container > ul > li');
    if (rows.length) {
      var header = rows[0];
      var priceRow = null;
      for (var r = 1; r < rows.length; r++) {
        var title = rows[r].querySelector('.row-title');
        if (title && title.textContent.trim().toLowerCase() === 'price') { priceRow = rows[r]; break; }
      }
      var money = function (cents) {
        return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      };
      var headCells = header.children;
      for (var i = 1; i < headCells.length; i++) {
        var cell = headCells[i];
        var link = cell.querySelector('a[href*="/products/"]');
        var span = cell.querySelector('.product-price');
        var parsed = [];
        if (priceRow && priceRow.children[i]) {
          parsed = priceRow.children[i].textContent.match(/\$[\d,]+(?:\.\d\d)?/g) || [];
        }
        if (!span && (parsed.length || link)) {
          span = document.createElement('span');
          span.className = 'product-price';
          if (parsed.length) span.textContent = parsed[0];
          var anchor = cell.querySelector('a') || cell;
          anchor.appendChild(span);
        }
        /* Hardcoded chart prices go stale \u2014 overwrite with the live price. */
        if (span && link) {
          (function (sp, href) {
            var m = href.match(/\/products\/([^\/?#]+)/);
            if (!m) return;
            fetch('/products/' + m[1] + '.js')
              .then(function (res) { return res.ok ? res.json() : null; })
              .then(function (p) {
                if (!p || typeof p.price !== 'number') return;
                sp.textContent = money(p.price);
                if (p.compare_at_price && p.compare_at_price > p.price) {
                  var s = document.createElement('s');
                  s.style.cssText = 'color:#8a8c8c;font-weight:normal;margin-left:6px;font-size:1rem;';
                  s.textContent = money(p.compare_at_price);
                  sp.appendChild(s);
                }
              })
              .catch(function () {});
          })(span, link.getAttribute('href'));
        }
      }
      if (priceRow) priceRow.parentNode.removeChild(priceRow);
    }

    if (!document.querySelector('.lrf-head')) {
      var head = document.createElement('div');
      head.className = 'lrf-head';
      head.style.cssText = 'text-align:center;padding-top:2rem;';
      head.innerHTML =
        '<div style="font-family:\'industry\',sans-serif;font-weight:bold;text-transform:uppercase;letter-spacing:2px;color:#fe5000;font-size:0.9rem;margin-bottom:0.5rem;">Side by Side</div>' +
        '<h3 style="font-family:\'industry\',sans-serif;font-weight:bold;color:#000;font-size:2.8rem;margin:0 0 0.5rem;">Compare Models</h3>' +
        '<div style="color:#8a8c8c;font-size:1rem;"><span style="color:#fe5000;">\u25CF</span> = included &nbsp;\u00B7&nbsp; <span style="color:#cccdcd;">\u25CB</span> = not available</div>';
      chart.parentNode.insertBefore(head, chart);
    }
  });
})();

